import { createContext, use } from "react";
import type { JSX, ReactNode } from "react";
import { silentClientLog } from "./clientLog";
import type { ClientLog } from "./clientLog";

const ClientLogContext = createContext<ClientLog>(silentClientLog);

/** Properties of {@link ClientLogProvider}. */
export interface ClientLogProviderProps {
  /** The log chosen in the composition root. */
  readonly log: ClientLog;
  /** Child elements. */
  readonly children: ReactNode;
}

/**
 * Provides the reports to the operator's log (F-68, ADR-0184).
 *
 * @param props - Component properties.
 * @returns The provider element.
 */
export function ClientLogProvider(props: ClientLogProviderProps): JSX.Element {
  const provider = <ClientLogContext value={props.log}>{props.children}</ClientLogContext>;

  return provider;
}

/**
 * Returns the reports to the operator's log; outside a {@link ClientLogProvider} nothing is
 * reported, so screens can be rendered on their own in tests.
 *
 * @returns The log.
 */
export function useClientLog(): ClientLog {
  const log = use(ClientLogContext);

  return log;
}
